module.exports = __webpack_public_path__ + "img/마스크 그룹 12@3x.965160c.png";